import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import MaintenanceMobileSubLinks from '@Components/Navigations/MaintenanceMobileSubLinks'
import RightsholderMaintenanceContactTab from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab'
import RightsholderMaintenanceBankingTab from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab'
import { PERMISSIONS } from '@Const/permissions'
import { StoresContext } from '@App/contexts'
import { MAINTENANCE_TABS } from '@Const/tabs-constants'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const RightsholderMaintenance = () => {
    const { uiStore, rightsholderUserStore } = useContext(StoresContext)

    const getTabs = (): Tab[] => {
        const myMaintenanceTabs: Tab[] = []
        if (
            rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
                PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address
            )
        ) {
            myMaintenanceTabs.push({
                tabName: MAINTENANCE_TABS.mailingAndContact.name,
                tabDisplayName: MAINTENANCE_TABS.mailingAndContact.name,
                tabDescription: MAINTENANCE_TABS.mailingAndContact.description,
                tabComponent: <RightsholderMaintenanceContactTab key={MAINTENANCE_TABS.mailingAndContact.name} />,
            })
        }
        if (
            rightsholderUserStore.doesRHUserHavePermission(PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax)
        ) {
            myMaintenanceTabs.push({
                tabName: MAINTENANCE_TABS.bankingAndTax.name,
                tabDisplayName: MAINTENANCE_TABS.bankingAndTax.name,
                tabDescription: MAINTENANCE_TABS.bankingAndTax.description,
                tabComponent: <RightsholderMaintenanceBankingTab key={MAINTENANCE_TABS.bankingAndTax.name} />,
            })
        }
        return myMaintenanceTabs
    }

    useEffect(() => {
        analyticsSendPage('rightsholder_maintenance')
    }, [])

    const myMaintenanceTabs = getTabs()
    if (!myMaintenanceTabs[0]) {
        return null
    }
    return (
        <>
            <title>Maintenance</title>
            <div className="rightsholder-maintenance-wrapper">
                {uiStore.isMobile && <MaintenanceMobileSubLinks />}
                <TabsWrapperComponent
                    tabs={myMaintenanceTabs}
                    defaultTab={myMaintenanceTabs[0]}
                    showContentHeaderPerTab
                />
            </div>
        </>
    )
}

export default observer(RightsholderMaintenance)
